module.exports = __webpack_public_path__ + "img/feature-illustration-4.8c18a42.svg";